import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";

const insurerLogoUrlCache = new Map<string, string>();
const insurerLogoFailedCache = new Set<string>();

const isDirectLogoUrl = (value?: string) => {
  if (!value) return false;
  return /^(https?:\/\/|data:|blob:|\/)/i.test(value.trim());
};

export const extractInsurerLogoFile = (insurer: unknown): string | undefined => {
  const insurerRecord = insurer as Record<string, unknown> | undefined;
  const rawLogo = insurerRecord?.insurer_logo;

  const normalizedLogo = String(rawLogo || "").trim();
  return normalizedLogo || undefined;
};

export const getImmediateInsurerLogoUrl = (name?: string, insurerLogoFile?: string) => {
  void name;
  const normalizedFile = String(insurerLogoFile || "").trim();

  if (!normalizedFile) {
    return { src: undefined as string | undefined, shouldResolveAsync: false };
  }

  if (isDirectLogoUrl(normalizedFile)) {
    return { src: normalizedFile, shouldResolveAsync: false };
  }

  const cachedLogo = insurerLogoUrlCache.get(normalizedFile);
  if (cachedLogo) {
    return { src: cachedLogo, shouldResolveAsync: false };
  }

  if (insurerLogoFailedCache.has(normalizedFile)) {
    return { src: undefined as string | undefined, shouldResolveAsync: false };
  }

  return { src: undefined as string | undefined, shouldResolveAsync: true };
};

export const resolveInsurerLogoDownloadUrl = async (
  name?: string,
  insurerLogoFile?: string
): Promise<string> => {
  void name;
  const normalizedFile = String(insurerLogoFile || "").trim();

  if (!normalizedFile) {
    return "";
  }

  if (isDirectLogoUrl(normalizedFile)) {
    return normalizedFile;
  }

  const cachedLogo = insurerLogoUrlCache.get(normalizedFile);
  if (cachedLogo) {
    return cachedLogo;
  }

  if (insurerLogoFailedCache.has(normalizedFile)) {
    return "";
  }

  try {
    const response = await axiosInstance.post(App_Url_New.ApiEndPoint.downloadDocument, {
      filename: normalizedFile,
    });

    const resolvedUrl = String(response?.data?.download_url || "").trim();
    if (resolvedUrl) {
      insurerLogoUrlCache.set(normalizedFile, resolvedUrl);
      insurerLogoFailedCache.delete(normalizedFile);
      return resolvedUrl;
    }

    insurerLogoFailedCache.add(normalizedFile);
  } catch (error) {
    console.error("Failed to resolve insurer logo via download API:", error);
    insurerLogoFailedCache.add(normalizedFile);
  }

  return "";
};
